export default __webpack_public_path__ + "static/media/ColorGroupAdd.4d4426b3.svg";